<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body">
  <div class="form-horizontal">
    <p>GILTI Consolidated Grid - Cell editor for HO LEID: {{ho_leid}}, HO CDR: {{ho_cdr_no}}</p>
  </div>
</div>

<div class="modal-footer">
  <button class="save-button"
    type="button"
    [disabled]="isSaveClicked"
    (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="cancel-button"
    type="button"
    (click)="cancel()">Cancel</button>
</div>
